import AppBar from "@material-ui/core/AppBar";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { createStyles, fade, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect } from "react";
import { Rnd } from "react-rnd";
import Results from "./Results";
import Tooltip from "@material-ui/core/Tooltip";
import { Button } from "@material-ui/core";
import { useActions, useValues } from "kea";
import Fuse from "fuse.js";
import CloseIcon from "@material-ui/icons/Close";

import assetlogic from "src/store/asset";
import { preferenceslogic, assetmaplogic } from "src/store/global";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			width: "100%",
			// height: "100%",
			minHeight: 0,
			flexGrow: 1,
		},
		container: {
			maxHeight: 440,
		},
		search: {
			position: "relative",
			borderRadius: theme.shape.borderRadius,
			backgroundColor: fade(theme.palette.common.white, 0.15),
			"&:hover": {
				backgroundColor: fade(theme.palette.common.white, 0.25),
			},
			marginRight: theme.spacing(2),
			marginLeft: 0,
			width: "100%",
			[theme.breakpoints.up("sm")]: {
				marginLeft: theme.spacing(3),
				width: "auto",
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: "100%",
			position: "absolute",
			pointerEvents: "none",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		inputRoot: {
			color: "inherit",
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create("width"),
			width: "100%",
			[theme.breakpoints.up("md")]: {
				width: "20ch",
			},
		},
	}),
);

const useStyles2 = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(1),
			width: "auto",
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			width: "15ch",
			"&:focus": {
				width: "20ch",
			},
		},
	},
	expand: {
		color: "white",
	},
	expandOpen: {
		color: "white",
	},
}));

const columns = [
	{
		field: "name",
		headerName: "Name",
		width: 325,
		align: "left",
	},
	{
		field: "actions",
		headerName: "Actions",
		align: "left",
		sortable: false,
		width: 190,
	},
];

const VehiclePanel = () => {
	const classes = useStyles();
	const classes2 = useStyles2();

	const { assets } = useValues(assetlogic);
	const { fetchAll } = useActions(assetlogic);

	const { asset, drawer } = useValues(preferenceslogic);
	const { setAsset } = useActions(preferenceslogic);

	const { assets: assetssOnMap } = useValues(assetmaplogic);
	const { addOne, removeOne } = useActions(assetmaplogic);

	const [showAllStatus, setShowAllStatus] = React.useState(false);
	const [filtered, setFiltered] = React.useState(assets);
	const [search, setSearch] = React.useState("");

	useEffect(() => {
		assets ?? fetchAll();
	}, []); // eslint-disable-line

	useEffect(() => {
		if (search === "") {
			setFiltered(assets);
		} else {
			const fuse = new Fuse(assets, {
				keys: ["type", "name", "company", "model", "year", "color"],
			});
			let found = fuse.search(search);
			found = found.map((item) => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [assets]); // eslint-disable-line

	useEffect(() => {
		if (search === "") {
			setFiltered(assets);
		} else {
			const fuse = new Fuse(assets, {
				keys: ["type", "name", "company", "model", "year", "color"],
			});
			let found = fuse.search(search);
			found = found.map((item) => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
			setAsset({ ...asset, expand: true });
		}
	}, [search]); // eslint-disable-line

	const handle_search = (e) => setSearch(e.target.value);

	const handleExpandClick = () => {
		setAsset({ ...asset, expand: !asset.expand });
	};

	const handleOnDrag = (e) => {
		setAsset({
			...asset,
			position: {
				x: e.layerX - e.offsetX - (drawer.expand ? 220 : 72),
				y: e.layerY - e.offsetY - 48,
			},
		});
	};

	const includes_mobile_vehicles_on_map = (mobile_vehicle) => {
		let flag = assetssOnMap.find((item) => {
			return item._id === mobile_vehicle._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	};

	// TODO Does not work with assets and beacons
	const handleShowAllButton = () => {
		let newShowAllStatus = !showAllStatus;
		setShowAllStatus(newShowAllStatus);
		if (!assetssOnMap.length) {
			if (filtered.length) {
				filtered.forEach((item) => {
					// console.log(item);
					if (item.beacon && item.beacon.positions.length > 0) {
						if (!includes_mobile_vehicles_on_map(item)) {
							addOne(item);
						}
					}
				});
			} else {
				assets.forEach((item) => {
					// console.log(item);
					if (item.beacon && item.beacon.positions.length > 0) {
						if (!includes_mobile_vehicles_on_map(item)) {
							addOne(item);
						}
					}
				});
			}
		} else {
			assets.forEach((item) => {
				// console.log(item);
				if (item.beacon && item.beacon.positions.length > 0) {
					if (includes_mobile_vehicles_on_map(item)) {
						removeOne(item);
					}
				}
			});
		}
	};

	return (
		<Rnd
			default={{
				x: asset.position.x,
				y: asset.position.y,
				width: 600,
			}}
			enableResizing={false}
			bounds={"#panelHolder"}
			onDragStop={handleOnDrag}
			cancel={"#rnd-ignore-drag"}
		>
			<Paper elevation={0} className={classes.root}>
				<div className={classes2.root}>
					<AppBar
						position="static"
						style={{
							height: "110px",
						}}
					>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<div
								style={{
									paddingLeft: "15px",
									paddingTop: "10px",
								}}
							>
								<Typography className={classes2.title} variant="h6" noWrap>
									Assets
								</Typography>
								<Typography className={classes2.title} variant="caption" noWrap>
									You can click and drag this panel.
								</Typography>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Tooltip title="Close this panel">
									<IconButton
										onClick={() =>
											setAsset({
												...asset,
												show: !asset.show,
												position: { x: 10, y: 180 },
											})
										}
										aria-label="less"
									>
										<Typography style={{ color: "white" }}>Close</Typography>
										<CloseIcon htmlColor="white" />
									</IconButton>
								</Tooltip>
							</div>
						</div>
						<Toolbar
							variant="dense"
							style={{
								paddingLeft: "0px",
								paddingRight: "0px",
								display: "flex",
								alignContent: "center",
							}}
						>
							<div
								id={"rnd-ignore-drag"}
								className={classes.search}
								style={{
									width: "330px",
								}}
							>
								<div className={classes.searchIcon}>
									<SearchIcon />
								</div>
								<InputBase
									fullWidth
									placeholder="Asset Search…"
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
									onChange={handle_search}
									inputProps={{ "aria-label": "search" }}
								/>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Tooltip title="Show all the Assets on the map">
									<Button
										variant="contained"
										color="primary"
										onClick={handleShowAllButton}
										endIcon={
											search && !assetssOnMap.length ? <SearchIcon /> : null
										}
									>
										{assetssOnMap.length > 0
											? "Hide All"
											: `Show ${search && !assetssOnMap.length ? "" : "All"}`}
									</Button>
								</Tooltip>
							</div>
							<div id={"rnd-ignore-drag"}>
								{asset.expand ? (
									<Tooltip title="Panel Collapse">
										<IconButton
											onClick={handleExpandClick}
											aria-label="less"
											className={classes.margin}
										>
											<Typography style={{ color: "white" }}>
												Collapse
											</Typography>
											<ExpandLessIcon htmlColor="white" />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip title="Panel Expand">
										<IconButton
											onClick={handleExpandClick}
											aria-label="more"
											className={classes.margin}
										>
											<Typography style={{ color: "white" }}>Expand</Typography>
											<ExpandMoreIcon htmlColor="white" />
										</IconButton>
									</Tooltip>
								)}
							</div>
						</Toolbar>
					</AppBar>
				</div>

				<Collapse
					id={"rnd-ignore-drag"}
					in={asset.expand}
					timeout="auto"
					unmountOnExit
					style={{ cursor: "default" }}
				>
					<Results rows={filtered} columns={columns} />
				</Collapse>
			</Paper>
		</Rnd>
	);
};

export default VehiclePanel;
